import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EligiblePet, EligiblePetsWrapper } from 'src/app/interfaces/pet';
import { ConfigService } from 'src/app/services/config/config.service';
import { PetplanService } from 'src/app/services/petplan/petplan.service';

@Component({
  selector: 'app-petplan-application-lite',
  templateUrl: './petplan-application-lite.component.html',
  styleUrl: './petplan-application-lite.component.scss'
})
export class PetplanApplicationLiteComponent {

  petPlanText1: string;
  petPlanCheckboxLabel: string;
  petPlanText2: string;
  isPetPlanCheckboxChecked: boolean;
  loading: boolean;
  eligiblePetsWrapper: EligiblePetsWrapper;
  eligiblePet: EligiblePet;

  constructor(
    private configService: ConfigService,
    private petplanService: PetplanService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) 
  {

    this.petPlanText1 = this.configService.getTextFromKey('pet-details-page-petplan-text-1');
    this.petPlanCheckboxLabel = this.configService.getTextFromKey('pet-details-page-petplan-checkbox-label');
    this.petPlanText2 = this.configService.getTextFromKey('pet-details-page-petplan-text-2');
    this.eligiblePetsWrapper = this.activatedRoute.snapshot.data.eligiblePets as EligiblePetsWrapper;
    this.eligiblePet = this.eligiblePetsWrapper.eligiblePets[0];
  }

  public checkValue(checked: boolean) {
    this.isPetPlanCheckboxChecked = checked;
  }

  public completeWelcomeGiftLite() {
    if (this.isPetPlanCheckboxChecked) {
      this.petplanService.petplanSave(this.eligiblePet.id).subscribe();
      this.router.navigate(['/dashboard']);
    }
  }
}
